export const uiPriceCard = {
    name: 'UI Price Card',
    description: '',
    displayField: 'context',
    fields: {
        price: {
            name: 'Price',
            type: 'Integer',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        context: {
            name: 'Context',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        description: {
            name: 'Description',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        buttonText: {
            name: 'Button Text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        buttonLink: {
            name: 'Button Link',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiPriceCard.js.map